import { render, staticRenderFns } from "./AgentsTable.vue?vue&type=template&id=1f89e5f4"
import script from "./AgentsTable.vue?vue&type=script&lang=js"
export * from "./AgentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports